import React, { useContext } from 'react';
import { StyledFooterCell } from './styled';
import { TableLayoutContext } from '../../layout-context';
const renderFooterRowLayoutMap = {
    table: ({ children, ...props }) => React.createElement(StyledFooterCell, { ...props }, children),
    block: ({ children, ...props }) => (React.createElement(StyledFooterCell, { role: "cell", as: "div", ...props }, children))
};
export const FooterCell = (props) => {
    const layoutType = useContext(TableLayoutContext);
    const renderFooterRow = renderFooterRowLayoutMap[layoutType];
    return renderFooterRow(props);
};
